import { render, staticRenderFns } from "./addPromoCard.vue?vue&type=template&id=3d1f45aa&scoped=true&"
import script from "./addPromoCard.vue?vue&type=script&lang=js&"
export * from "./addPromoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1f45aa",
  null
  
)

export default component.exports